exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-landing-page-tsx": () => import("./../../../src/pages/LandingPage.tsx" /* webpackChunkName: "component---src-pages-landing-page-tsx" */),
  "component---src-templates-project-detail-tsx": () => import("./../../../src/templates/ProjectDetail.tsx" /* webpackChunkName: "component---src-templates-project-detail-tsx" */)
}

